module.exports = __webpack_public_path__ + "img/Flag_of_East_Timor.865b4b1f.svg";